import {
  FETCH_APPLICATION_LIST_REQUEST,
  FETCH_APPLICATION_LIST_SUCCESS,
  FETCH_APPLICATION_LIST_CONSTANTS_SUCCESS,
  FETCH_REGIONS_BY_NAME_SUCCESS,
} from './applicationsDashboardActions';

import initialState from './applicationsDashboardInitialState';

const applicationsDashboardReducer = (state = initialState(), { type, payload }) => {
  switch (type) {
    case FETCH_APPLICATION_LIST_REQUEST: {
      const newState = {
        ...state,
        isCallInprogress: true,
      };
      return newState;
    }

    case FETCH_APPLICATION_LIST_SUCCESS: {
      const {
        page,
        total,
        applications,
      } = payload;

      const newState = {
        ...state,
        isCallInprogress: false,
        applications: {
          totalElements: total || 0,
          page,
          records: Array.isArray(applications) ? applications : [],
        },
      };

      return newState;
    }

    case FETCH_APPLICATION_LIST_CONSTANTS_SUCCESS: {
      const {
        STATUS,
      } = payload;

      const newState = {
        ...state,
        constants: {
          STATUS: Array.isArray(STATUS) ? STATUS : [],
        },
      };
      return newState;
    }

    case FETCH_REGIONS_BY_NAME_SUCCESS: {
      const { programRegions } = payload;
      const newState = {
        ...state,
        regionList: [...programRegions],
      };
      return newState;
    }

    default:
      return state;
  }
};

export default applicationsDashboardReducer;
